import { render, staticRenderFns } from "./processComment.vue?vue&type=template&id=5deb002a&"
import script from "./processComment.vue?vue&type=script&lang=js&"
export * from "./processComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports